// extracted by mini-css-extract-plugin
module.exports = {"preview":"style_preview__3knZC","table":"style_table__3-40Z"};